import { ArticlePage, PRArticlePage } from "services/cms/models";
import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";
import { RelatedArticles } from "services/cms/models/relatedArticles";

import articleCardResolver, { ResolvedArticleCard } from "./articleCardResolver";
import { ResolvedMegaMenuCtaButton, transformCtaButton } from "./headerMegaMenuCTAResolver";

export interface ResolvedRelatedArticles {
    codename?: string;
    type?: ContentTypeCodenames.RelatedArticles;
    header: string;
    relatedArticles: ResolvedArticleCard[];
    cta?: ResolvedMegaMenuCtaButton | null;
    hasSmallerGap?: boolean;
}

const relatedArticlesResolver = (data: RelatedArticles): ResolvedRelatedArticles => {
    const linkedArticles = (data.elements.articles.linkedItems || []) as (
        | ArticlePage
        | PRArticlePage
    )[];

    const cta = data.elements.cta;

    return {
        codename: data.system.codename,
        header: data.elements.heading.value,
        relatedArticles: linkedArticles.map(articleCardResolver),
        cta: cta?.linkedItems[0] ? transformCtaButton(cta?.linkedItems[0]) : null,
        type: ContentTypeCodenames.RelatedArticles,
    };
};

export default relatedArticlesResolver;
